import client from '../httpClient';

const libraryGetApi = (libraryId) => {
  return client.get(`/libraries/${libraryId}`);
};

export default libraryGetApi;
